import React,{useContext} from "react";
import { Row, Col, Container } from "react-bootstrap";
import './homeCompnents.css'
import { RimligIcon } from "./HomeSvg";
import { SignSvg } from "./HomeSvg";
import { LanguageContext } from "../context/LanguageContext";
const HeroSection = () => {
  const { translations } = useContext(LanguageContext);
  return (
    <div className="rm_hero">
     <div className="rm_hero_side_bg">
     <Container>
        <Row>
          <Col lg="6">
          <div className="rm_content">
            <h6 className="rm_subheading">{translations?.homepage?.subTitle}</h6>
            <div className="position-relative">
            <h1 className="position-relative"
                  dangerouslySetInnerHTML={{ __html: translations?.homepage?.title }}>
              </h1>
            <span className="position-absolute start-0 sign">{SignSvg}</span>
            </div>
            <p>{translations?.homepage?.description}</p>
            <button className="rm_cmn_btn d-flex align-items-center gap-2 ">{RimligIcon}{translations?.homepage?.buttonText}</button>
          </div>

          </Col>
        </Row>
      </Container>
      <div className="mobile_image">
          <img src="/assets/images/mobile_image.svg" className="img-fluid"  alt="rimlig image"/>
      </div>
     </div>
    </div>
  );
};

export default HeroSection;
